import React from 'react';
import './page.css';
import MainTitle from '../../components/page/main-title/MainTitle';
import ButtonAdd from '../../components/form/ButtonAdd';
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import Container from '../../components/container/Container';
import Modal from '../../components/modal/Modal';
import Page from './Page';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import { Closest } from '../../utils/htmlnodes/Selectors';
import Loader from "../../components/loader/Loader";
import Paginacao from '../../components/paginacao/Paginacao';

const URL_REMOVE_ITEM = WS.planilhas_treino.remove;
const URL_BLOCOS_LISTA = WS.planilhas_treino.lista;
const URL_DETALHE_ITEM = WS.planilhas_treino.detalhe;

class PlanilhaTreino extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      isLoading: true
    }

    this.handleClick = this.handleClick.bind(this);
    this.btEditClick = this.btEditClick.bind(this);
    this.remove = this.remove.bind(this);
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this.pageHandler = this.pageHandler.bind(this);

  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url:URL_BLOCOS_LISTA,
      data:{local_treino: 'academia'},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.items,
            page: data.page

          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  componentWillUnmount() {

  }

  onRemoveItem (e,data){
    Dialog.destroy();
    const {
      msgRemover,
      atencao,
      fechar,
      remover,
      itemRemovidoSucesso,
      impossivelRemoverItem,
      erroRemover
    } = this.state.strings;
    //----------------
    const id = data.id;
    const item = Closest(e,'.item-listagem');

    Requisitions({
      url:URL_REMOVE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;
        if(data.status){
          msg = {
            title: atencao,
            text: itemRemovidoSucesso
          };

          //remove o item
          item.remove();
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
        }
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroRemover
        });
      }
    });
    //----------------
  }

  remove (element) {
    const button = element.currentTarget;
    const {msgRemover,atencao,fechar,remover} = this.state.strings;
    const _self = this;
    const item = Closest(button,'.item-listagem');
    const id = item.getAttribute('data-id');

    this.checkId(id);

    Dialog.create({
      type: Dialog.CONFIRM,
      title: atencao,
      text: msgRemover,
      txtCancel: fechar,
      txtOk: remover,
      onSubmit: (el) => {
        _self.onRemoveItem(button,{id:id});
        el.preventDefault();
      }
    });
    element.preventDefault();
  }

  checkId (id){
    const {atencao,impossivelRemoverItem} = this.state.strings;
    if(!id){
      Dialog.create({
        title: atencao,
        text: impossivelRemoverItem
      });
      return false;
    }
  }

  addPage (data){
    const history = this.props.history;
    return new Promise((resolve, reject) => {
      var modal = new Modal();
      modal.open({page:<Page modal={modal} detalhe={data} history={history}  />});
      resolve(true);
  });

  }

  btEditClick (e){
    const item = Closest(e.currentTarget,'.item-listagem');
    const id = item.getAttribute('data-id');
    const {atencao,erroDetalhe,carregandoPlanilha} = this.state.strings;
    this.checkId(id);

    const self = this;

    Requisitions({
      url:URL_DETALHE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;

        if(data.status){
          let modal = new Loader();
          modal.open({title:carregandoPlanilha});
          setTimeout(function(){

            self.addPage(data.item)
            .then(() =>{
              modal.close();
            })
            .catch(reason => {});
          },3000)

        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }

      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroDetalhe
        });
      }
    });

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  handleClick (e){
    var modal = new Modal();
    const history = this.props.history;
    modal.open({page:<Page modal={modal} history={history} />});

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  pageHandler(val){

    const {atencao} = this.state.strings;
    let _self = this;
    Requisitions({
      url:URL_BLOCOS_LISTA,
      data:{ page: val, local_treino: 'academia'},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.items,
            page: data.page
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  render (){

    let lista = this.state.lista.map((value, i) =>
        <ItemSimplesListagem id={value.id} value={`${value.nome} (${value.dti} - ${value.dtf})`} key={i} btEditClick={this.btEditClick}  btRemoveClick={this.remove}></ItemSimplesListagem>
      );

    if(lista.length<=0){
      lista = <EmptyList />
    }

    const { titlePlanilhasTreino } = this.state.strings;
    let wrapper = this.state.isLoading ? <LoadingPage /> : lista;

    return (
      <Container>
        <MainTitle title={titlePlanilhasTreino}></MainTitle>
        <ButtonAdd myClick={this.handleClick}></ButtonAdd>
          <div className="listagem">
            {wrapper}
          </div>
          <Paginacao data={this.state.page} pageHandler={this.pageHandler} />

      </Container>
    );
  }
}

export default PlanilhaTreino;



// WEBPACK FOOTER //
// ./src/classes/planilha-treino/PlanilhaTreino.js